import PreparatoryQuickEntryPage from './_PreparatoryQuickEntryPage'

export default function ComberQuickEntryPage() {
  return <PreparatoryQuickEntryPage kind="comber" />
}
